import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CalendarListModule } from '@tokeet/ngx-calendar-list'

import { SharedModule } from '@tv3/shared/shared.module'
import { RentalRatesDialogComponent } from './rental-rates-dialog/rental-rates-dialog.component'
import { RentalRatesCalendarComponent } from './rental-rates-calendar/rental-rates-calendar.component'
import { RentalRatesCalendarCellComponent } from './rental-rates-calendar/rental-rates-calendar-cell/rental-rates-calendar-cell.component'
import { EditRateDialogComponent } from './edit-rate-dialog/edit-rate-dialog.component'
import { RatesTableComponent } from './rates-table/rates-table.component'
import { EditRateDialogService } from './edit-rate-dialog/edit-rate-dialog.service'
import { EditChannelAdjustmentDialogService } from './edit-channel-adjustment-dialog/edit-channel-adjustment-dialog.service'
import { EditChannelAdjustmentDialogComponent } from './edit-channel-adjustment-dialog/edit-channel-adjustment-dialog.component'
import { RentalRateMappingsTableComponent } from './rental-rate-mappings-table/rental-rate-mappings-table.component'
import { AddRateMappingDialogService } from './add-rate-mapping-dialog/add-rate-mapping-dialog.service'
import { AddRateMappingDialogComponent } from './add-rate-mapping-dialog/add-rate-mapping-dialog.component'
import { RentalRateSettingsComponent } from './rental-rate-settings/rental-rate-settings.component'
import { ChannelAdjustmentsTableComponent } from './channel-adjustments-table/channel-adjustments-table.component'
import { AccountRatesDialogComponent } from './account-rates-dialog/account-rates-dialog.component'
import { AccountRatesDialogService } from './account-rates-dialog/account-rates-dialog.service'
import { RentalRatesDialogService } from './rental-rates-dialog/rental-rates-dialog.service'
import { RateDetailsPopoverComponent } from './rate-details-popover/rate-details-popover.component'
import { CalendarSharedModule } from '../calendar/shared/calendar-shared.module'
import { InquiriesSharedModule } from '@tv3/containers/inquiries/shared/inquiries-shared.module'
import { LosDiscountTableComponent } from '@tv3/containers/rates/los-discount/los-discount-table.component'
import { DiscountCodesTableComponent } from '@tv3/containers/rates/discount-code/discount-codes-table.component'
import { RentalDiscountsComponent } from '@tv3/containers/rates/rental-discounts/rental-discounts.component'
import { DiscountsModule } from '@tv3/containers/discounts/discounts.module'
import { PushRatesOverlayComponent } from '@tv3/containers/rates/push-rates/push-rates-overlay.component'
import { PushRatesOverlayService } from '@tv3/containers/rates/push-rates/push-rates-overlay.service'
import { RateMappingsTableComponent } from './push-rates/rate-mappings-table/rate-mappings-table.component'

const modules = [
  SharedModule,
  CommonModule,
  CalendarListModule,
  InquiriesSharedModule,
  CalendarSharedModule,
  DiscountsModule,
]

const components = [
  RentalRatesCalendarComponent,
  RentalRatesCalendarCellComponent,
  RatesTableComponent,
  ChannelAdjustmentsTableComponent,
  RentalRateMappingsTableComponent,
  RentalRateSettingsComponent,
  RateDetailsPopoverComponent,
  LosDiscountTableComponent,
  DiscountCodesTableComponent,
  RentalDiscountsComponent,
  RentalRatesDialogComponent,
  EditRateDialogComponent,
  EditChannelAdjustmentDialogComponent,
  AddRateMappingDialogComponent,
  AccountRatesDialogComponent,
  PushRatesOverlayComponent,
  RateMappingsTableComponent,
]

const services = [
  EditRateDialogService,
  EditChannelAdjustmentDialogService,
  AddRateMappingDialogService,
  RentalRatesDialogService,
  AccountRatesDialogService,
  PushRatesOverlayService,
]

@NgModule({
  imports: [...modules],
  declarations: [...components],
  exports: [...components, ...modules],
  providers: [...services],
})
export class RatesSharedModule {}
